import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { tallyBy } from "@/utils/tally";
import type { TradeRow } from "./TradeTable";

interface TradeSummaryCardProps {
  trades: TradeRow[];
}

/**
 * Buy/Sell counts are a tally of already-fetched trade records by their
 * backend-reported `side` field - never a derived financial value.
 * "Today's Trades" and "Last Updated" have no backend timestamp field to
 * filter or source from (`ExecutionOrderDto` carries none) and render as
 * unavailable rather than fabricated.
 */
export function TradeSummaryCard({ trades }: TradeSummaryCardProps): React.JSX.Element {
  const bySide = tallyBy(trades, (t) => t.side);

  return (
    <StatusCard title="Trade Summary">
      <Stack spacing={1.5}>
        <MetricCard label="Total Trades" value={trades.length} />
        <MetricCard label="Today's Trades" value={null} />
        <MetricCard label="Buy Trades" value={bySide.BUY ?? 0} />
        <MetricCard label="Sell Trades" value={bySide.SELL ?? 0} />
        <MetricCard label="Last Updated" value={null} />
      </Stack>
    </StatusCard>
  );
}
